import { cn } from "@tellescope/ui";
import type { HeadingBlock as HeadingBlockType } from "../../../shared/schema";

interface HeadingBlockProps {
  text: HeadingBlockType["props"]["text"];
  level: HeadingBlockType["props"]["level"];
}

const levelStyles: Record<HeadingBlockType["props"]["level"], string> = {
  h1: "text-4xl font-bold tracking-tight",
  h2: "text-3xl font-semibold tracking-tight",
  h3: "text-2xl font-semibold",
  h4: "text-xl font-medium",
};

export const HeadingBlock: React.FC<HeadingBlockProps> = ({ text, level = "h2" }) => {
  if (!text) return null;

  const Tag = level;
  return (
    <Tag
      className={cn(levelStyles[level], "text-foreground break-words")}
      style={{ fontFamily: "var(--portal-heading-font, inherit)" }}
    >
      {text}
    </Tag>
  );
};
